export default defineNuxtPlugin(() => {
  return {
    provide: {
      debounce(callback: (...args: any[]) => void, wait = 1000) {
        let timeoutId: ReturnType<typeof setTimeout> | null = null;
        return (...args: any[]) => {
          if (timeoutId) clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            callback(...args);
          }, wait);
        };
      },
    },
  };
});